const initKongressiTable = () => {
  document.addEventListener("DOMContentLoaded", () => {
    const tableWrapper = document.querySelector(".kongresi-table.table-wrapper");
    if (!tableWrapper) return;
    let isDown = false;
    let startY;
    let startX;
    let scrollLeft;
    let scrollTop;

    tableWrapper.addEventListener("mousedown", (e) => {
      isDown = true;
      tableWrapper.style.cursor = "grabbing";
      startY = e.pageY - tableWrapper.offsetTop;
      startX = e.pageX - tableWrapper.offsetLeft;
      scrollLeft = tableWrapper.scrollLeft;
      scrollTop = tableWrapper.scrollTop;
    });

    tableWrapper.addEventListener("mouseleave", () => {
      isDown = false;
      tableWrapper.style.cursor = "grab";
    });

    tableWrapper.addEventListener("mouseup", () => {
      isDown = false;
      tableWrapper.style.cursor = "grab";
    });

    tableWrapper.addEventListener("mousemove", (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - tableWrapper.offsetLeft;
      const y = e.pageY - tableWrapper.offsetTop;
      const walkY = y - startY;
      const walkX = x - startX;
      tableWrapper.scrollTop = scrollTop - walkY;
      tableWrapper.scrollLeft = scrollLeft - walkX;
    });
  });
};

export default initKongressiTable;
